import React, { useState, useEffect } from 'react'
// import { DataGrid, useGridParamsApi } from '@material-ui/data-grid';
import { DataGrid} from '@mui/x-data-grid';
import { Button } from "@material-ui/core";
import moment from "moment"
import "./table.css"
import { useAuthState } from "@bamboobox/b2logincheck";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { MuiThemeProvider } from "@material-ui/core";
import UItheme from "@bamboobox/b2-theme"
import Alert from '@mui/material/Alert';
import FGrid from './FGrid';

let schema = [
  { name: 'company_name' },
  { name: 'source' },
  { name: 'page_visits' },
  { name: 'company_website' },
  { name: 'company_size_range' },
  { name: 'surging_country' },
  { name: 'company_industry' },
  { name: 'topics_data' },
  { name: 'intent_creation_date', type:"datetime" },
  {name: 'source_details'}
];

const NewAccountManager = (props) => {
  toast.configure({
    autoClose: 6000,
    draggable: true,
    hideProgressBar: false,
    position: toast.POSITION.BOTTOM_LEFT,
    icon: true,
  });


  const userDetails = useAuthState();
  const permissions = userDetails?.permissions;
  const resourceNames=['all_source_net_new'];
  const tenantId = userDetails.user.tenantId;
  const [intentData ,setIntentData]  = useState([]);

  const getTopicList = (topicsData) => {
    let topicArr = []
    if (topicsData) {
      let arrOfTopic = topicsData.split('""')
      for (let topicStr of arrOfTopic) {
        let topic = topicStr.split('\\"')[1]
        if (topic) {
          topic = topic.substring(0, topic.length - 1)
          topicArr.push(topic)
        }
      }
    }
    return topicArr.join()
  }

  function checkPermision(tenantId, permissions, resourceNames){
    console.log("permissions ->",permissions);
    for(var objIdx=0;objIdx<permissions.length;objIdx++){
    if(tenantId && permissions[objIdx]?.operations?.length>0 && resourceNames.includes(permissions[objIdx]?.resourceName))
       return true
     }
   return false
}

  let rowDataArr = []

  useEffect(() => {
    const isPermission = checkPermision(tenantId,permissions,resourceNames);
    console.log("isPermission->",permissions);
    if (!isPermission) {
      schema = schema.filter(s => s. name !== 'source_details' );
    }  
},[]);

  function formatString(input) {
    return input
        ?.split(',') // Split the string by commas
        ?.map(word => 
            word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase() // Capitalize the first letter, lowercase the rest
        )
        ?.join(', '); // Join the words back with a comma and space
  }

  const setTableData = () => {
    
    if (props?.previewData?.msg === "EMPTY") {
      toast.warn(<Alert severity="warn">No pending requests available</Alert>,{
        closeOnClick: true,
        autoClose: true,
        closeButton: true,
        newestOnTop: true
      });
    } else {
      let counter=0;
      props?.previewData?.data?.forEach(obj => {
        counter++;
        let rowDataObject = {
          company_name: "",
          company_website: "",
          b2_intent_level: "",
          intent_creation_date: "",
          company_industry:"",
          company_size_range:"",
          surging_country:"",
          page_visits: "",
          source: "",
          source_details:""
        }
        rowDataObject.company_name = obj.company_name || ""
        rowDataObject.company_website = obj.company_website || ""
        rowDataObject.company_industry = obj.company_industry || ""
        rowDataObject.surging_country = obj.surging_country || ""
        rowDataObject.company_size_range = obj.company_size_range || ""
        rowDataObject.topics_data = getTopicList(obj.topics_data_aggr) || ""
        rowDataObject.intent_creation_date = moment(obj.last_intent_date).format('YYYY-MM-DD') || ""
        rowDataObject.page_visits = obj.page_visits?.map((ele) => {
          if (!ele.hostname && ele.page_path) {
            return ele.page_path.replace(/^https?:\/\//, '');
          }
          return `${ele.hostname}${ele.page_path}`;
        })
        .join(', ') || "";
        rowDataObject.source = formatString(obj.source?.replace(/[\[\]']+/g, '')) || "";
        rowDataObject.source_details = obj?.source_details?.map(ele => {
          let sourceValue = '';
          if(ele?.source && (ele?.formName || ele?.campaignName)){
              let s = `${formatString(ele?.source)} : ${ele?.formName || ele?.campaignName}`;
              if(sourceValue.length) {
                  s = `, ${s}`
              }
              sourceValue = sourceValue.concat(s)
          }
          return sourceValue;
      }) || "";
        rowDataArr.push(rowDataObject)
      })
      setIntentData(rowDataArr);

      console.log(`%c${JSON.stringify(rowDataArr)}`, 'background:black;color:white')
    }
  }
 
  useEffect(() => {

    setTableData()
      
  }, [props?.previewData])


  return (
    <MuiThemeProvider theme={UItheme}>
      <FGrid 
        data={intentData}
        schema={schema}
      />
    </MuiThemeProvider>
  );
}

export default NewAccountManager;